import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TabsModule } from 'beyond-util';
import { AriannaGledanostEmisijeComponent } from './arianna-gledanost-emisije.component';

@NgModule({
  declarations: [AriannaGledanostEmisijeComponent],
  entryComponents: [AriannaGledanostEmisijeComponent],
  exports: [AriannaGledanostEmisijeComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class AriannaGledanostEmisijeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/arianna-gledanost-emisije/arianna-gledanost-emisije.module.ts